import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';

const Welcome = observer((props) => {
    const [chatReady, setChatReady] = useState(false);
    const [fullAgreement, setFullAgreement] = useState(false);
    const [startingChatSession, setStartingChatSession] = useState(false);

    const agreementItems = [
        { id: 'prepared', label: 'Once you start a chat, do not leave and come back, you will loose your place in line.' },
        { id: 'polite', label: 'Please be polite and courteous during the conversation.' },
        { id: 'informative', label: 'Please provide as much information as possible.' },
      ];

    useEffect(() => {
        // Create a script element
        const script = document.createElement('script');
        
        // Set the source to the external script
        script.src = 'https://smarterservices.my.site.com/ESWSmarterProctoring1692215353845/assets/js/bootstrap.min.js'; // replace with the actual URL of your script
        
        // Ensure the script is loaded before calling the function
        script.onload = () => {
            /* eslint-disable no-undef */
            if (window.embeddedservice_bootstrap) {
            
                window.embeddedservice_bootstrap.settings.language = 'en_US'; // For example, enter 'en' or 'en-US'
                window.embeddedservice_bootstrap.settings.hideChatButtonOnLoad = true;
                window.embeddedservice_bootstrap.init(
                    '00D4100000082BE',
                    'SmarterProctoring',
                    'https://smarterservices.my.site.com/ESWSmarterProctoring1692215353845',
                    {
                        scrt2URL: 'https://smarterservices.my.salesforce-scrt.com'
                    }
                );
            }
            /* eslint-enable no-undef */
        };
    
        // Append the script to the document body
        document.body.appendChild(script);


        window.addEventListener("onEmbeddedMessagingReady", (e) => {
            console.log("Received the onEmbeddedMessagingReady event…");
            
            setChatReady(true);

            setTimeout(()=>{
                console.log("focus");
                window.focus();
            }, 10000)
            
            // For some reason this is not working but the docs says it should....
            if(window.embeddedservice_bootstrap.prechatAPI?.setVisiblePrechatFields){
                window.embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields({
                    "_firstName": {
                        "value": "Jason",
                        "isEditableByEndUser": true
                    },
                    "_lastName": {
                        "value": "Fill",
                        "isEditableByEndUser": true
                    },
                    "_email": {
                        "value": "jason@smarterservices.com",
                        "isEditableByEndUser": true
                    },
                });
            }

            const prechat = {
                "UserRole" : "student"
                ,"InstallSid" : "AI62678ae6437b48de9763ad0236c60a51"
                ,"SessionSid" : "ES445247a3b4b74150a2f640a15fe2569d"
                
                ,"DevicePlatform" : e.target.clientInformation.platform
            };

            window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields(prechat);
            
        });
      }, []);

      function launchChat() { 
        setStartingChatSession(true);
        window.embeddedservice_bootstrap.utilAPI.launchChat()
            .then(() => {
                // Success handler used to perform actions
                // when the chat client launches successfully.
                // For example, create a method that disables the launch chat button.

                //disableLaunchChatButton();
            }).catch((e) => {
                // Error handler used to perform actions
                // if the chat client fails to launch.
                // For example, create a method that hides the launch chat button.
                console.log(e);
                //hideLaunchChatButton();

            }).finally(() => {
                // Finally handler used to perform any clean-up actions
                // regardless of whether the chat client launches successfully or not.
                // For example, create a method that logs the user’s attempt to chat.
                console.log("Finally");
                setStartingChatSession(false);
                //logEndUserAttemptToChat();
            });
    }

    function updateChatAgreementStatus(){
        let allChecked = true;
        const checkboxes = document.querySelectorAll('.chat-agreement');
        checkboxes.forEach(checkbox => {
            if(!checkbox.checked){
                allChecked = false;
            }
        });        
        setFullAgreement(allChecked);
    }

  return (
    <>
        {props.store.SessionStore.matchingBroadcasts.length > 0 ? (
            <>
                <p>Thank you for taking the time to review the ongoing issues and confirm they do not apply to you.</p>
            </>
        ) : (
            <p>{props.store.SessionStore.firstName},</p>
        )}
        
        <p>
            Prior to connecting to an agent, please indicate you understand the following:

            {agreementItems.map((agreement) => (
                <div className="form-check mt-3" key={agreement.id}>
                <input
                    className="form-check-input chat-agreement"
                    type="checkbox"
                    value=""
                    id={agreement.id}
                    onChange={updateChatAgreementStatus}
                />
                <label className="form-check-label" htmlFor={agreement.id}>
                    {agreement.label}
                </label>
                </div>
            ))}

            {chatReady && fullAgreement ? (
                <>
                <div className="mt-4 text-center">
                    {!startingChatSession ? (
                        <p className=''>
                            <button type="button" class="btn btn-primary" onClick={launchChat}>Proceed To Chat</button>
                        </p>
                    ) : (
                        <>
                        <div class="spinner-border spinner-border-sm text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div> Loading Chat
                        </> 
                    )}
                </div>
                </>
            ) : (<></>)}
            
        </p>
    </>
  );
});

export default Welcome;